// Mock data for MediSeller website

export const heroData = {
  title: "Save 60% on Authentic Medications",
  subtitle: "45 Years of Trust | 100% Original Generic Medications from India",
  description: "International cross-border pharmacy delivering doorstep medications to 30+ countries via express air shipping",
  ctaText: "Get Your Medications",
  image: "https://images.unsplash.com/photo-1758573467057-955f803660a9"
};

export const aboutData = {
  title: "About MediSeller",
  description: "With 45 years of excellence in pharmaceutical services, MediSeller is your trusted partner for authentic generic medications from India. We hold all necessary licenses and certifications to ensure the highest quality standards.",
  stats: [
    { number: "45+", label: "Years of Experience" },
    { number: "30+", label: "Countries Served" },
    { number: "5000+", label: "Products Available" },
    { number: "100%", label: "Authentic Medications" }
  ],
  advantages: [
    {
      title: "60% Cost Savings",
      description: "Save more than 60% on your medication costs without compromising on quality or authenticity",
      icon: "DollarSign",
      image: "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2"
    },
    {
      title: "100% Authentic Sourcing",
      description: "All medications are sourced directly from licensed manufacturers with full traceability and verification",
      icon: "ShieldCheck",
      image: "https://images.unsplash.com/photo-1563213126-a4273aed2016"
    },
    {
      title: "Express Air Shipping",
      description: "Fast and secure doorstep delivery to 30+ countries using reliable express air shipping services",
      icon: "Plane",
      image: "https://images.pexels.com/photos/7363103/pexels-photo-7363103.jpeg"
    },
    {
      title: "45 Years Experience",
      description: "Nearly half a century of trusted pharmaceutical services with all necessary licenses and certifications",
      icon: "Award",
      image: "https://images.unsplash.com/photo-1580281657702-257584239a55"
    },
    {
      title: "Expert Consultation",
      description: "Our expert team connects with you to help source medications and provide verified suppliers from all over India. Chat with us on WhatsApp for instant assistance.",
      icon: "Users",
      image: "https://images.unsplash.com/photo-1758573467057-955f803660a9",
      whatsappCTA: true,
      whatsappNumber: "+919876543210"
    },
    {
      title: "Licensed & Certified",
      description: "Fully licensed with partnerships with major pharmaceutical companies worldwide",
      icon: "FileCheck",
      image: "https://images.unsplash.com/photo-1580281658223-9b93f18ae9ae"
    }
  ]
};

export const pharmaPartnersData = {
  title: "Top 20 Pharmaceutical Partners",
  subtitle: "Working with leading Indian and international pharmaceutical manufacturers",
  partners: [
    { name: "Sun Pharma", logo: "https://via.placeholder.com/150x80?text=Sun+Pharma", type: "Indian" },
    { name: "Cipla", logo: "https://via.placeholder.com/150x80?text=Cipla", type: "Indian" },
    { name: "Dr. Reddy's", logo: "https://via.placeholder.com/150x80?text=Dr+Reddy%27s", type: "Indian" },
    { name: "Lupin", logo: "https://via.placeholder.com/150x80?text=Lupin", type: "Indian" },
    { name: "Aurobindo", logo: "https://via.placeholder.com/150x80?text=Aurobindo", type: "Indian" },
    { name: "Torrent Pharma", logo: "https://via.placeholder.com/150x80?text=Torrent", type: "Indian" },
    { name: "Zydus Cadila", logo: "https://via.placeholder.com/150x80?text=Zydus", type: "Indian" },
    { name: "Glenmark", logo: "https://via.placeholder.com/150x80?text=Glenmark", type: "Indian" },
    { name: "Alkem Labs", logo: "https://via.placeholder.com/150x80?text=Alkem", type: "Indian" },
    { name: "Abbott India", logo: "https://via.placeholder.com/150x80?text=Abbott", type: "Indian" },
    { name: "Mankind Pharma", logo: "https://via.placeholder.com/150x80?text=Mankind", type: "Indian" },
    { name: "Biocon", logo: "https://via.placeholder.com/150x80?text=Biocon", type: "Indian" },
    { name: "Cadila Healthcare", logo: "https://via.placeholder.com/150x80?text=Cadila", type: "Indian" },
    { name: "Pfizer", logo: "https://via.placeholder.com/150x80?text=Pfizer", type: "International" },
    { name: "Novartis", logo: "https://via.placeholder.com/150x80?text=Novartis", type: "International" },
    { name: "GlaxoSmithKline", logo: "https://via.placeholder.com/150x80?text=GSK", type: "International" },
    { name: "Sanofi", logo: "https://via.placeholder.com/150x80?text=Sanofi", type: "International" },
    { name: "Merck", logo: "https://via.placeholder.com/150x80?text=Merck", type: "International" },
    { name: "AstraZeneca", logo: "https://via.placeholder.com/150x80?text=AstraZeneca", type: "International" },
    { name: "Johnson & Johnson", logo: "https://via.placeholder.com/150x80?text=J%26J", type: "International" }
  ]
};

export const topProductsData = {
  title: "Top 20 Best-Selling Products",
  subtitle: "Our most popular authentic generic medications",
  products: [
    { name: "Sildenafil 100mg", category: "ED Treatment", price: "$2.50", savings: "65%" },
    { name: "Tadalafil 20mg", category: "ED Treatment", price: "$3.20", savings: "68%" },
    { name: "Metformin 500mg", category: "Diabetes", price: "$0.80", savings: "70%" },
    { name: "Atorvastatin 10mg", category: "Cholesterol", price: "$1.20", savings: "62%" },
    { name: "Amlodipine 5mg", category: "Blood Pressure", price: "$0.90", savings: "67%" },
    { name: "Omeprazole 20mg", category: "Acid Reflux", price: "$1.10", savings: "64%" },
    { name: "Losartan 50mg", category: "Blood Pressure", price: "$1.50", savings: "60%" },
    { name: "Levothyroxine 100mcg", category: "Thyroid", price: "$0.95", savings: "69%" },
    { name: "Gabapentin 300mg", category: "Pain Relief", price: "$1.80", savings: "63%" },
    { name: "Sertraline 50mg", category: "Mental Health", price: "$1.60", savings: "66%" },
    { name: "Lisinopril 10mg", category: "Blood Pressure", price: "$1.00", savings: "65%" },
    { name: "Simvastatin 20mg", category: "Cholesterol", price: "$1.30", savings: "61%" },
    { name: "Finasteride 5mg", category: "Hair Loss", price: "$2.00", savings: "70%" },
    { name: "Pantoprazole 40mg", category: "Acid Reflux", price: "$1.40", savings: "62%" },
    { name: "Clopidogrel 75mg", category: "Heart Health", price: "$1.70", savings: "68%" },
    { name: "Rosuvastatin 10mg", category: "Cholesterol", price: "$1.90", savings: "64%" },
    { name: "Tamsulosin 0.4mg", category: "Prostate Health", price: "$2.10", savings: "66%" },
    { name: "Escitalopram 10mg", category: "Mental Health", price: "$1.50", savings: "67%" },
    { name: "Montelukast 10mg", category: "Asthma", price: "$1.20", savings: "69%" },
    { name: "Allopurinol 300mg", category: "Gout", price: "$1.00", savings: "65%" }
  ]
};

export const howToOrderData = {
  title: "How to Order",
  subtitle: "Simple 4-step process to get your medications delivered",
  steps: [
    {
      number: "01",
      title: "Submit Your Requirements",
      description: "Fill out our contact form with your medication needs or upload your prescription",
      icon: "FileText"
    },
    {
      number: "02",
      title: "Expert Consultation",
      description: "Our expert team will connect with you to verify requirements and suggest the best options",
      icon: "UserCheck"
    },
    {
      number: "03",
      title: "Secure Payment",
      description: "Receive a quote and complete payment through our secure payment gateway",
      icon: "CreditCard"
    },
    {
      number: "04",
      title: "Express Delivery",
      description: "Receive your 100% authentic medications at your doorstep via express air shipping",
      icon: "Package"
    }
  ],
  image: "https://images.unsplash.com/photo-1653794280510-6d0c380449a7"
};

export const testimonialsData = {
  title: "What Our Customers Say",
  subtitle: "Trusted by thousands of patients worldwide",
  testimonials: [
    {
      name: "Robert M.",
      country: "United States",
      rating: 5,
      text: "I've been ordering from MediSeller for 3 years now. The savings are incredible and the quality is always top-notch. Delivery is fast and reliable!",
      date: "2 months ago"
    },
    {
      name: "Sarah K.",
      country: "United Kingdom",
      rating: 5,
      text: "Amazing service! I save over $500 every month on my medications. The team is professional and always available to answer questions.",
      date: "1 month ago"
    },
    {
      name: "Michael P.",
      country: "Canada",
      rating: 5,
      text: "Finally found a trustworthy source for affordable medications. The 45 years of experience really shows in their service quality.",
      date: "3 weeks ago"
    },
    {
      name: "Emma L.",
      country: "Australia",
      rating: 5,
      text: "Express air shipping is super fast! Got my order in just 10 days. All medications were properly packaged and authentic.",
      date: "2 weeks ago"
    },
    {
      name: "David R.",
      country: "Germany",
      rating: 5,
      text: "The consultation process was thorough and professional. They helped me find the exact medications I needed at 60% less cost!",
      date: "1 week ago"
    },
    {
      name: "Lisa W.",
      country: "Singapore",
      rating: 5,
      text: "Excellent experience from start to finish. The team is knowledgeable and the savings are substantial. Highly recommend!",
      date: "3 days ago"
    }
  ],
  backgroundImage: "https://images.unsplash.com/photo-1580281657702-257584239a55"
};

export const contactFormData = {
  title: "Get Started Today",
  subtitle: "Fill out the form and our expert team will reach out to you",
  formFields: [
    { name: "fullName", label: "Full Name", type: "text", placeholder: "John Doe", required: true },
    { name: "email", label: "Email Address", type: "email", placeholder: "john@example.com", required: true },
    { name: "phone", label: "Phone Number", type: "tel", placeholder: "+1 234 567 8900", required: true },
    { name: "country", label: "Country", type: "text", placeholder: "United States", required: true },
    { name: "medication", label: "Medication Name(s)", type: "text", placeholder: "Enter medication names", required: false },
    { name: "message", label: "Message / Requirements", type: "textarea", placeholder: "Tell us about your medication needs...", required: true }
  ],
  ctaText: "Submit Request"
};

export const footerData = {
  company: "MediSeller",
  tagline: "Your trusted international pharmacy since 1980",
  description: "Providing 100% authentic generic medications from India to 30+ countries with express air shipping.",
  links: {
    company: [
      { name: "About Us", href: "#about" },
      { name: "Our Partners", href: "#partners" },
      { name: "How to Order", href: "#order" }
    ],
    products: [
      { name: "Top Products", href: "#products" },
      { name: "All Medications", href: "#products" },
      { name: "Supplements", href: "#products" }
    ],
    support: [
      { name: "Contact Us", href: "#contact" },
      { name: "FAQ", href: "#faq" },
      { name: "Shipping Info", href: "#order" }
    ]
  },
  copyright: "© 2025 MediSeller. All rights reserved."
};
